import { render, staticRenderFns } from "./Boleto.vue?vue&type=template&id=be817cbc&scoped=true&"
import script from "./Boleto.vue?vue&type=script&lang=js&"
export * from "./Boleto.vue?vue&type=script&lang=js&"
import style0 from "./Boleto.vue?vue&type=style&index=0&id=be817cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be817cbc",
  null
  
)

export default component.exports